export default __webpack_public_path__ + "static/media/mobile.401f4864.png";